import {useContext, useEffect} from 'react';
import { useTransition, animated } from 'react-spring';
import SETTINGS from '../settings';
import {useToggle} from 'react-use';

import ErrorBoundary from '../utils/error-boundary';

import log from 'loglevel';

import RecipeContext from '../utils/recipe-context';
import {RECIPES, findIDBySlug} from '../recipes/recipe-list.js';

const RecipeContainer = props => {
  const recipeContext = useContext(RecipeContext);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [recipeContext.currentRecipeID]);

  const recipeTransition = useTransition(recipeContext.currentRecipeID, null, {
    config:SETTINGS.ANIMATION.DEFAULT,
    from: { opacity: 0 },
    enter: { opacity: 1},
    leave: { position:'absolute', opacity: 0 }
  });

  return recipeTransition.map(({item, key, props}) => {
    const Recipe = RECIPES[item].recipe;
    return(
      <animated.div key={key} style={props}>
        <ErrorBoundary>
          <Recipe title={RECIPES[item].name}/>
        </ErrorBoundary>
      </animated.div>
    );
  });
};

export default RecipeContainer;
